// Tytuł publikacji to jednowierszowy HTML z kursywą oraz indeksem górnym
// i dolnym (API: App\Lib\TitleMarkup). Strona nie wstrzykuje HTML-a — tytuł
// dzielimy na tekst i te trzy znaczniki, resztę znaczników pomijamy.
export const TITLE_ELEMENTS = ['i', 'sup', 'sub']
const TAG_ALIASES = { em: 'i' }

const NAMED_ENTITIES = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
}

export const decodeTitleEntities = (value) =>
  String(value || '').replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, code) => {
    if (code[0] === '#') {
      const point = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10)

      return Number.isNaN(point) ? entity : String.fromCodePoint(point)
    }

    return NAMED_ENTITIES[code.toLowerCase()] ?? entity
  })

const collapseWhitespace = (value) => value.replace(/\s+/g, ' ').trim()

// [{ text }, { tag: 'i', children: [...] }] — znaczniki bez pary są pomijane.
export const parseTitle = (value) => {
  const root = { children: [] }
  const stack = [root]
  const parts = String(value || '').split(/(<\/?[a-z][a-z0-9]*\b[^>]*>)/i)

  parts.forEach((part) => {
    if (!part) {
      return
    }

    const tag = part.match(/^<(\/?)([a-z][a-z0-9]*)/i)
    if (!tag) {
      stack[stack.length - 1].children.push({
        text: decodeTitleEntities(part),
      })

      return
    }

    const name = TAG_ALIASES[tag[2].toLowerCase()] || tag[2].toLowerCase()
    if (/^(br|p|div|li|h[1-6])$/.test(name)) {
      stack[stack.length - 1].children.push({ text: ' ' })

      return
    }
    if (!TITLE_ELEMENTS.includes(name)) {
      return
    }
    if (!tag[1]) {
      const node = { tag: name, children: [] }
      stack[stack.length - 1].children.push(node)
      stack.push(node)
    } else if (stack.length > 1 && stack[stack.length - 1].tag === name) {
      stack.pop()
    }
  })

  return root.children
}

const nodesToText = (nodes) => nodes.map((node) => (node.children ? nodesToText(node.children) : node.text)).join('')

export const titleToText = (value) => collapseWhitespace(nodesToText(parseTitle(value)))

// Punkty kodowe, jak mb_strlen w API (emoji to jeden znak, nie dwa).
export const getTitleLength = (value) => [...titleToText(value)].length

export const isTitleBlank = (value) => titleToText(value) === ''

const escapeText = (value) => value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

const nodesToHtml = (nodes) =>
  nodes
    .map((node) => (node.tag ? `<${node.tag}>${nodesToHtml(node.children)}</${node.tag}>` : escapeText(node.text)))
    .join('')

// Bezpieczny HTML tytułu (tylko i, sup, sub; tekst zakodowany) — do miejsc,
// które składają HTML z napisów, np. cytowania.
export const titleToHtml = (value) => nodesToHtml(parseTitle(value)).replace(/\s+/g, ' ').trim()
